<template>
  <div class="skeleton__table">
    <div
      class="skeleton__table__preheader"
    >
      <Skeleton :class="['skeleton__table__preheader__text', { 'skeleton__table__preheader__text--long': isCcrs }]" />
      <Skeleton
        v-if="!isCcrs"
        class="skeleton__table__preheader__entries"
        :shape="'rectangle'"
      />
    </div>
    <div class="skeleton__table__header">
      <Skeleton class="skeleton__table__header__text" />
    </div>
    <div
      class="skeleton__table__content"
    >
      <div
        class="skeleton__table__content__row"
        v-for="row in dummyArray"
        :key="row.index"
      >
        <Skeleton
          class="skeleton__table__content__row__picture"
          :shape="'circle'"
        />
        <Skeleton class="skeleton__table__content__row__text__long" />
        <Skeleton class="skeleton__table__content__row__icon" />
      </div>
    </div>
  </div>
</template>
<script>
import {Skeleton} from '@progress/kendo-vue-indicators'

export default {
  name: 'ProductTableSkeleton',
  components: {
    Skeleton
  },
  props: {
    // when true, use the longer preheader text skeleton for CCRS
    isCcrs: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let dummyArray = new Array(25).fill({index: 0}).map((e, i) => e.index = i)
    return {
      dummyArray: dummyArray
    }
  }
}
</script>

<style lang="scss">
.skeleton__table {
  .skeleton__table__preheader__text--long {
    width: 35rem;
  }
}
</style>
